// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qpIb","col":"styles_col__2UV0e"};